// Cloudflare Turnstile, the bot check on asking for a sign-in code. Its script
// loads only when the server has the check on (GET /api/login/options).

export interface Turnstile {
  render(el: HTMLElement, options: Record<string, unknown>): string;
  reset(id: string): void;
  remove(id: string): void;
}

declare global {
  interface Window {
    turnstile?: Turnstile;
  }
}

let loading: Promise<Turnstile> | null = null;

export function loadTurnstile(): Promise<Turnstile> {
  if (window.turnstile) return Promise.resolve(window.turnstile);
  loading ??= new Promise<Turnstile>((resolve, reject) => {
    const s = document.createElement("script");
    s.src = "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit";
    s.async = true;
    s.onload = () => (window.turnstile ? resolve(window.turnstile) : reject(new Error("The bot check did not start.")));
    s.onerror = () => {
      loading = null;
      s.remove();
      reject(new Error("The bot check could not load."));
    };
    document.head.appendChild(s);
  });
  return loading;
}
